<template>
  <div class="w-full h-full flex items-center justify-center bg-gradient-to-br ">

    <!-- Login Container -->
    <div class="w-[440px] bg-trader-gray flex flex-col backdrop-blur p-10 bg-white/90 drop-shadow-xl shadow-black rounded-lg">



      <!-- Login Form -->
      <div data-ui="login-grey-background " class="flex flex-col ">

        <!-- Header -->
        <h1 data-ui="login-headline" class="text-2xl font-bold mb-8">
          <span class="text-black" style="text-shadow: 0px 0px 20px white;">TRADER</span>
          <span class="text-[#a8282e]" style="text-shadow: 0px 0px 20px white;">.</span>
          <br>
          <span class="text-[#bcbaad] text-xl" style="text-shadow: 0px 0px 20px white;">BENUTZERANMELDUNG</span>
        </h1>

        <!-- Input Fields -->
        <input
            class="rounded p-3 mt-5 border border-gray-300 focus:outline-none focus:border-[#a8282e] focus:ring-1 focus:ring-[#a8282e] transition-all"
            type="text"
            maxlength="30"
            placeholder="Kunde"
            data-ui="customer"
            v-model="inputCustomer"
            @keyup.enter="onClickLogin"
        />

        <input
            class="rounded p-3 mt-5 border border-gray-300 focus:outline-none focus:border-[#a8282e] focus:ring-1 focus:ring-[#a8282e] transition-all"
            type="text"
            name="username"
            autocomplete="on"
            maxlength="30"
            placeholder="Benutzer"
            data-ui="username"
            v-model="inputUsername"
            @keyup.enter="onClickLogin"
        />

        <input
            class="rounded p-3 mt-5 border border-gray-300 focus:outline-none focus:border-[#a8282e] focus:ring-1 focus:ring-[#a8282e] transition-all"
            type="password"
            name="password"
            autocomplete="on"
            maxlength="30"
            placeholder="Passwort"
            data-ui="password"
            v-model="inputPassword"
            @keyup.enter="onClickLogin"
        />

        <!-- Password Recovery Link -->

        <span class="my-5 text-[#a8282e] hover:text-[#8a2025] cursor-pointer transition-colors"
              data-ui="login-password-recovery">
            Passwort vergessen?
        </span>

        <!-- Error Message -->
        <div data-ui="login-wrong-password-message "
             v-if="wrongPassword"
             class="bg-red-50 border border-red-300 text-red-700 px-4 py-3 rounded mb-5 text-sm">
          Die eingegebenen Benutzerdaten sind nicht korrekt!
        </div>

        <!-- Login Button -->
        <button data-ui="login-button"
                class="bg-[#a8282e] hover:bg-[#8a2025] text-white rounded p-3 font-semibold transition-all duration-200 transform hover:scale-[1.01] active:scale-[0.99] mt-auto"
                type="button"
                v-on:click="onClickLogin">
          Anmelden
        </button>

      </div>

    </div>

  </div>
</template>

<script>

import {eventBus} from "@/application/EventBus.js";
import axios from "axios";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      inputCustomer: '',
      inputUsername: '',
      inputPassword: '',
      wrongPassword: false,
    }
  },
  methods: {
    async login() {
      await this.onClickLogin();
      eventBus.closeModal();

      try {
        if (this.value.onAccept) {
          this.value.onAccept();
        }
      } catch (e) {
      }

    },
    async onClickLogin() {
      // Hash-Funktion für SHA-256
      const hashPassword = async (password) => {
        const encoder = new TextEncoder();
        const data = encoder.encode(password);
        const hashBuffer = await crypto.subtle.digest('SHA-1', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        return hashHex;
      };

      try {
        const hashedPassword = await hashPassword(this.inputPassword);

        const response = await axios.post('/api/v3/login', {
          client: this.inputCustomer,
          username: this.inputUsername,
          password: this.inputPassword
        });

        this.wrongPassword = false;

        let newUser = {
          client: this.inputCustomer,
          username: this.inputUsername,
          password: hashedPassword
        };
        let users = JSON.parse(localStorage.getItem('users') || '[]');
        const userExists = users.some(
            user => user.username === newUser.username && user.client === newUser.client
        );
        if (!userExists) {
          users.push(newUser);
        }

        localStorage.setItem('users', JSON.stringify(users));

        // Seite neu laden nach erfolgreichem Speichern
        window.location.reload();

      } catch (error) {
        this.wrongPassword = true;
      }
    },
    deleteFalse() {
      eventBus.closeModal();

      try {
        if (this.value.onCancel) {
          this.value.onCancel();
        }
      } catch (e) {
      }


    }
  },


}


</script>

